<template>
  <Form function-type="update"/>
</template>

<script>
import Form from './Form';

export default {
  name: "Update",
  components: {Form}
}
</script>

<style scoped>

</style>